import { React, models, kea, history, resources, selectores, componentToRx, Route, match, validation, createSelectorRx, formfields, fa } from "app/main/std";
import { DatosFacturacion } from "./types";
import { DatosFacturacionComponent, validar } from "./datosfacturacion";

import { omit } from "keautils";
import { Button } from "kea-react";

export function validarDatosFacturacion(x: models.Cliente, tipoPersona: models.TipoPersona | null) {
    return validar(mapValue(x), tipoPersona);
}

/**Mapea un cliente a un valor para el componente de edición */
function mapValue(c: models.Cliente): DatosFacturacion {
    return {
        ...(c.DatosFacturacion || {}),
        IdDatosFacturacionColonia: c.IdDatosFacturacionColonia,
    };
}

/**Mapea un cambio para el componente de edición */
function mapChange(change: DatosFacturacion, x: models.Cliente): models.Cliente {
    return {
        ...x,
        DatosFacturacion: omit(change, ["IdDatosFacturacionColonia"]),
        IdDatosFacturacionColonia: change.IdDatosFacturacionColonia,
    };
}


export interface Props {
    value: models.Cliente;
    tipoPersona: models.TipoPersona | null;
    onChange: (value: models.Cliente) => PromiseLike<void>;
    readonly?: boolean;
}

/**
 * Devuelve un nuevo cliente con la direccion de facturación cambiada (no modifica el cliente "old")
 */
function cambiarDireccionFiscal(old: models.Cliente, direccion: models.Direccion, idColonia: number | null): models.Cliente {
    //DatosFacturacion.Direccion
    
     return {
        ... old,
        IdDatosFacturacionColonia: idColonia,
        DatosFacturacion: {
            ... old.DatosFacturacion,
            Direccion: direccion
        }
    };
 }

/**
* Componente para editar un models.Cliente
*/
export class DatosFacturacionCliente extends React.PureComponent<Props> {
    onChange = async (x: DatosFacturacion) => {
        await this.props.onChange(mapChange(x, this.props.value));
    }

    onCopiar = () => {
        //1.- Obtener nuevoValue:
        const value = this.props.value;
        const direccion = value.DatosCredito.DireccionCobranza;
        const idColonia = value.IdDatosCreditoColonia;
        const nuevoValue = cambiarDireccionFiscal(value, direccion, idColonia );
        
        //2.- Lamar al onChange
        this.props.onChange(nuevoValue);
    }

    render() {
        const value = mapValue(this.props.value);
        return (
            <div className="panel panel-info">
                <div className="panel-heading">
                    <span>
                        <i className={fa("dollar")} />
                        Datos de facturación
                    </span> 
                </div>
                <div className="panel-body"> 
                    <DatosFacturacionComponent value={value} onChange={this.onChange} tipoPersona={this.props.tipoPersona} readonly={this.props.readonly} />
                </div>
            </div>
        )

    }
}


// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/clientes/edit/componentes/datosfacturacioncliente.tsx